var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.24 0H10.753V13.8275H0V47.249H57.389V20.7415H45.24V0ZM55.935 45.795V22.196H45.24V45.795H55.935ZM36.982 36.024V45.795H43.7855V36.024H36.982ZM28.7235 36.024V45.795H35.5275V36.024H28.7235ZM20.4655 36.024V45.795H27.2695V36.024H20.4655ZM12.2075 36.024V45.795H19.0115V36.024H12.2075ZM10.753 45.795V15.282H1.454V45.795H10.753ZM12.2075 29.11V34.5695H19.0115V29.11H12.2075ZM20.4655 29.11V34.5695H27.2695V29.11H20.4655ZM28.7235 29.11V34.5695H35.5275V29.11H28.7235ZM36.982 29.11V34.5695H43.7855V29.11H36.982ZM19.0115 27.6555V22.196H12.2075V27.6555H19.0115ZM27.2695 27.6555V22.196H20.4655V27.6555H27.2695ZM35.5275 27.6555V22.196H28.7235V27.6555H35.5275ZM43.7855 27.6555V22.196H36.982V27.6555H43.7855ZM12.2075 15.282V20.7415H19.0115V15.282H12.2075ZM20.4655 15.282V20.7415H27.2695V15.282H20.4655ZM28.7235 15.282V20.7415H35.5275V15.282H28.7235ZM36.982 15.282V20.7415H43.7855V15.282H36.982ZM12.2075 8.368V13.8275H19.0115V8.368H12.2075ZM20.4655 8.368V13.8275H27.2695V8.368H20.4655ZM28.7235 8.368V13.8275H35.5275V8.368H28.7235ZM36.982 8.368V13.8275H43.7855V8.368H36.982ZM12.2075 1.454V6.914H19.0115V1.454H12.2075ZM20.4655 1.454V6.914H27.2695V1.454H20.4655ZM28.7235 1.454V6.914H35.5275V1.454H28.7235ZM36.982 1.454V6.914H43.7855V1.454H36.982Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.b2b175816f066218b652ed1582cf6a12.svg";
export { ForwardRef as ReactComponent };